import { GenIcon } from '../helpers/IconBase.es.js';

const WashingOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.75 3.5C6.05964 3.5 5.5 4.05964 5.5 4.75V8.25H18.5V4.75C18.5 4.05964 17.9404 3.5 17.25 3.5H6.75ZM5.5 19.25V9.75H18.5V19.25C18.5 19.9404 17.9404 20.5 17.25 20.5H6.75C6.05964 20.5 5.5 19.9404 5.5 19.25ZM4 4.75C4 3.23122 5.23122 2 6.75 2H17.25C18.7688 2 20 3.23122 20 4.75V19.25C20 20.7688 18.7688 22 17.25 22H6.75C5.23122 22 4 20.7688 4 19.25V4.75ZM9.5 15C9.5 13.6193 10.6193 12.5 12 12.5C13.3807 12.5 14.5 13.6193 14.5 15C14.5 16.3807 13.3807 17.5 12 17.5C10.6193 17.5 9.5 16.3807 9.5 15ZM12 11C9.79086 11 8 12.7909 8 15C8 17.2091 9.79086 19 12 19C14.2091 19 16 17.2091 16 15C16 12.7909 14.2091 11 12 11ZM13 7C13.5523 7 14 6.55228 14 6C14 5.44772 13.5523 5 13 5C12.4477 5 12 5.44772 12 6C12 6.55228 12.4477 7 13 7ZM17 6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6C15 5.44772 15.4477 5 16 5C16.5523 5 17 5.44772 17 6Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { WashingOutlined };
